import { render } from "./assets.vue?vue&type=template&id=6b24f0f6"
import script from "./assets.vue?vue&type=script&lang=js"
export * from "./assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__